import hcAxios, { RequestOptions } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// wallet
enum API {
  // 查询支持的区块链
  WalletChainSupportedChains = '/web3/wallet/chain/supported-chains',
  // 综合币价
  WalletTokenCurrentPrice = '/web3/wallet/token/current-price',
  // 实时币价
  WalletTokenRealTimePrice = '/web3/wallet/token/real-time-price',
  // 历史币价
  WalletTokenHistoricalPrice = '/web3/wallet/token/historical-price',
  // 项目信息
  WalletTokenTokenDetail = '/web3/wallet/token/token-detail',
  // 地址总估值
  WalletAssetTotalValueByAddress = '/web3/wallet/asset/total-value-by-address',
  // 地址资产明细
  WalletAssetAllTokenBalancesByAddress = '/web3/wallet/asset/all-token-balances-by-address',
  // 地址 查询特定代币
  WalletAssetTokenBalancesByAddress = '/web3/wallet/asset/token-balances-by-address',
  // 地址 查询持有的 UTXO
  WalletUtxoUtxos = '/web3/wallet/utxo/utxos',
  // 地址 查 UTXO 上铭文
  WalletUtxoUtxoDetail = '/web3/wallet/utxo/utxo-detail',
  // 地址 查询授权
  WalletSecurityApprovals = '/web3/wallet/security/approvals',
  // 账户 总估值
  WalletAssetTotalValue = '/web3/wallet/asset/total-value',
  // 账户 资产明细
  WalletAssetWalletAllTokenBalances = '/web3/wallet/asset/wallet-all-token-balances',
  // 账户 查询特定代币
  WalletAssetTokenBalances = '/web3/wallet/asset/token-balances',
  // 地址维度查询
  WalletPostTransactionTransactionsByAddress = '/web3/wallet/post-transaction/transactions-by-address',
  // 账户维度查询
  WalletPostTransactionTransactions = '/web3/wallet/post-transaction/transactions',
  // 查询特定 Tx
  WalletPostTransactionTransactionDetailByTxhash = '/web3/wallet/post-transaction/transaction-detail-by-txhash',
  // 查询铭文交易
  WalletPostTransactionInscriptionTransactionDetailByTxhash = '/web3/wallet/post-transaction/inscription-transaction-detail-by-txhash',
  // 创建账户
  WalletAccountCreateWalletAccount = '/web3/wallet/account/create-wallet-account',
  // 更新账户
  WalletAccountUpdateWalletAccount = '/web3/wallet/account/update-wallet-account',
  // 删除账户
  WalletAccountDeleteAccount = '/web3/wallet/account/delete-account',
  // 查询账户
  WalletAccountAccounts = '/web3/wallet/account/accounts',
  // 查询账户下的地址
  WalletAccountAccountDetail = '/web3/wallet/account/account-detail',
  // 签名所需数据
  WalletPreTransactionSignInfo = '/web3/wallet/pre-transaction/sign-info',
  // Gas Price
  WalletPreTransactionGasPrice = '/web3/wallet/pre-transaction/gas-price',
  // Gas Limit
  WalletPreTransactionGasLimit = '/web3/wallet/pre-transaction/gas-limit',
  // Nonce
  WalletPreTransactionNonce = '/web3/wallet/pre-transaction/nonce',
  // SUI Object
  WalletPreTransactionSuiObject = '/web3/wallet/pre-transaction/sui-object',
  // 地址校验
  WalletPreTransactionValidateAddress = '/web3/wallet/pre-transaction/validate-address',
  // 交易广播
  WalletPreTransactionBroadcastTransaction = '/web3/wallet/pre-transaction/broadcast-transaction',
  // 查广播订单列表
  WalletPostTransactionOrders = '/web3/wallet/post-transaction/orders',
}

export type TPostWalletChainSupportedChainsParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletChainSupportedChainsResponse = TResponse<string>
export const postWalletChainSupportedChains = (
  params?: TPostWalletChainSupportedChainsParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletChainSupportedChainsResponse>(API.WalletChainSupportedChains, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletTokenCurrentPriceParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletTokenCurrentPriceResponse = TResponse<string>
export const postWalletTokenCurrentPrice = (params?: TPostWalletTokenCurrentPriceParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWalletTokenCurrentPriceResponse>(API.WalletTokenCurrentPrice, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletTokenRealTimePriceParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletTokenRealTimePriceResponse = TResponse<string>
export const postWalletTokenRealTimePrice = (
  params?: TPostWalletTokenRealTimePriceParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletTokenRealTimePriceResponse>(API.WalletTokenRealTimePrice, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletTokenHistoricalPriceParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletTokenHistoricalPriceResponse = TResponse<string>
export const postWalletTokenHistoricalPrice = (
  params?: TPostWalletTokenHistoricalPriceParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletTokenHistoricalPriceResponse>(API.WalletTokenHistoricalPrice, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletTokenTokenDetailParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletTokenTokenDetailResponse = TResponse<string>
export const postWalletTokenTokenDetail = (params?: TPostWalletTokenTokenDetailParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWalletTokenTokenDetailResponse>(API.WalletTokenTokenDetail, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletAssetTotalValueByAddressParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAssetTotalValueByAddressResponse = TResponse<string>
export const postWalletAssetTotalValueByAddress = (
  params?: TPostWalletAssetTotalValueByAddressParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletAssetTotalValueByAddressResponse>(API.WalletAssetTotalValueByAddress, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletAssetAllTokenBalancesByAddressParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAssetAllTokenBalancesByAddressResponse = TResponse<string>
export const postWalletAssetAllTokenBalancesByAddress = (
  params?: TPostWalletAssetAllTokenBalancesByAddressParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletAssetAllTokenBalancesByAddressResponse>(
    API.WalletAssetAllTokenBalancesByAddress,
    params,
    {
      options: {
        signature: 'decrypted',
      },
    }
  )
}

export type TPostWalletAssetTokenBalancesByAddressParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAssetTokenBalancesByAddressResponse = TResponse<string>
export const postWalletAssetTokenBalancesByAddress = (
  params?: TPostWalletAssetTokenBalancesByAddressParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletAssetTokenBalancesByAddressResponse>(API.WalletAssetTokenBalancesByAddress, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletUtxoUtxosParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletUtxoUtxosResponse = TResponse<string>
export const postWalletUtxoUtxos = (params?: TPostWalletUtxoUtxosParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWalletUtxoUtxosResponse>(API.WalletUtxoUtxos, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletUtxoUtxoDetailParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletUtxoUtxoDetailResponse = TResponse<string>
export const postWalletUtxoUtxoDetail = (params?: TPostWalletUtxoUtxoDetailParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWalletUtxoUtxoDetailResponse>(API.WalletUtxoUtxoDetail, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletSecurityApprovalsParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletSecurityApprovalsResponse = TResponse<string>
export const postWalletSecurityApprovals = (params?: TPostWalletSecurityApprovalsParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWalletSecurityApprovalsResponse>(API.WalletSecurityApprovals, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletAssetTotalValueParams = {
  bizData?: any
  randomIv?: any
  randomKey?: any
  signature?: any
  timestamp?: any
}
export type TPostWalletAssetTotalValueResponse = TResponse<string>
export const postWalletAssetTotalValue = (params?: TPostWalletAssetTotalValueParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWalletAssetTotalValueResponse>(API.WalletAssetTotalValue, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletAssetWalletAllTokenBalancesParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAssetWalletAllTokenBalancesResponse = TResponse<string>
export const postWalletAssetWalletAllTokenBalances = (
  params?: TPostWalletAssetWalletAllTokenBalancesParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletAssetWalletAllTokenBalancesResponse>(API.WalletAssetWalletAllTokenBalances, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletAssetTokenBalancesParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAssetTokenBalancesResponse = TResponse<string>
export const postWalletAssetTokenBalances = (
  params?: TPostWalletAssetTokenBalancesParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletAssetTokenBalancesResponse>(API.WalletAssetTokenBalances, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletPostTransactionTransactionsByAddressParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPostTransactionTransactionsByAddressResponse = TResponse<string>
export const postWalletPostTransactionTransactionsByAddress = (
  params?: TPostWalletPostTransactionTransactionsByAddressParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPostTransactionTransactionsByAddressResponse>(
    API.WalletPostTransactionTransactionsByAddress,
    params,
    { options: { signature: 'decrypted' } }
  )
}

export type TPostWalletPostTransactionTransactionsParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPostTransactionTransactionsResponse = TResponse<string>
export const postWalletPostTransactionTransactions = (
  params?: TPostWalletPostTransactionTransactionsParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPostTransactionTransactionsResponse>(API.WalletPostTransactionTransactions, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletPostTransactionTransactionDetailByTxhashParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPostTransactionTransactionDetailByTxhashResponse = TResponse<string>
export const postWalletPostTransactionTransactionDetailByTxhash = (
  params?: TPostWalletPostTransactionTransactionDetailByTxhashParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPostTransactionTransactionDetailByTxhashResponse>(
    API.WalletPostTransactionTransactionDetailByTxhash,
    params,
    {
      options: {
        signature: 'decrypted',
      },
    }
  )
}

export type TPostWalletPostTransactionInscriptionTransactionDetailByTxhashParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPostTransactionInscriptionTransactionDetailByTxhashResponse = TResponse<string>
export const postWalletPostTransactionInscriptionTransactionDetailByTxhash = (
  params?: TPostWalletPostTransactionInscriptionTransactionDetailByTxhashParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPostTransactionInscriptionTransactionDetailByTxhashResponse>(
    API.WalletPostTransactionInscriptionTransactionDetailByTxhash,
    params,
    {
      options: {
        signature: 'decrypted',
      },
    }
  )
}

export type TPostWalletAccountCreateWalletAccountParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAccountCreateWalletAccountResponse = TResponse<string>
export const postWalletAccountCreateWalletAccount = (
  params?: TPostWalletAccountCreateWalletAccountParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletAccountCreateWalletAccountResponse>(API.WalletAccountCreateWalletAccount, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletAccountUpdateWalletAccountParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAccountUpdateWalletAccountResponse = TResponse<string>
export const postWalletAccountUpdateWalletAccount = (
  params?: TPostWalletAccountUpdateWalletAccountParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletAccountUpdateWalletAccountResponse>(API.WalletAccountUpdateWalletAccount, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletAccountDeleteAccountParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAccountDeleteAccountResponse = TResponse<string>
export const postWalletAccountDeleteAccount = (
  params?: TPostWalletAccountDeleteAccountParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletAccountDeleteAccountResponse>(API.WalletAccountDeleteAccount, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletAccountAccountsParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAccountAccountsResponse = TResponse<string>
export const postWalletAccountAccounts = (params?: TPostWalletAccountAccountsParams, options?: RequestOptions) => {
  return hcAxios.post<TPostWalletAccountAccountsResponse>(API.WalletAccountAccounts, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletAccountAccountDetailParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletAccountAccountDetailResponse = TResponse<string>
export const postWalletAccountAccountDetail = (
  params?: TPostWalletAccountAccountDetailParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletAccountAccountDetailResponse>(API.WalletAccountAccountDetail, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletPreTransactionSignInfoParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPreTransactionSignInfoResponse = TResponse<string>
export const postWalletPreTransactionSignInfo = (
  params?: TPostWalletPreTransactionSignInfoParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPreTransactionSignInfoResponse>(API.WalletPreTransactionSignInfo, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletPreTransactionGasPriceParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPreTransactionGasPriceResponse = TResponse<string>
export const postWalletPreTransactionGasPrice = (
  params?: TPostWalletPreTransactionGasPriceParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPreTransactionGasPriceResponse>(API.WalletPreTransactionGasPrice, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletPreTransactionGasLimitParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPreTransactionGasLimitResponse = TResponse<string>
export const postWalletPreTransactionGasLimit = (
  params?: TPostWalletPreTransactionGasLimitParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPreTransactionGasLimitResponse>(API.WalletPreTransactionGasLimit, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletPreTransactionNonceParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPreTransactionNonceResponse = TResponse<string>
export const postWalletPreTransactionNonce = (
  params?: TPostWalletPreTransactionNonceParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPreTransactionNonceResponse>(API.WalletPreTransactionNonce, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletPreTransactionSuiObjectParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPreTransactionSuiObjectResponse = TResponse<string>
export const postWalletPreTransactionSuiObject = (
  params?: TPostWalletPreTransactionSuiObjectParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPreTransactionSuiObjectResponse>(API.WalletPreTransactionSuiObject, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostWalletPreTransactionValidateAddressParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPreTransactionValidateAddressResponse = TResponse<string>
export const postWalletPreTransactionValidateAddress = (
  params?: TPostWalletPreTransactionValidateAddressParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPreTransactionValidateAddressResponse>(
    API.WalletPreTransactionValidateAddress,
    params,
    {
      options: {
        signature: 'decrypted',
      },
    }
  )
}

export type TPostWalletPreTransactionBroadcastTransactionParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPreTransactionBroadcastTransactionResponse = TResponse<string>
export const postWalletPreTransactionBroadcastTransaction = (
  params?: TPostWalletPreTransactionBroadcastTransactionParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPreTransactionBroadcastTransactionResponse>(
    API.WalletPreTransactionBroadcastTransaction,
    params,
    {
      options: {
        signature: 'decrypted',
      },
    }
  )
}

export type TPostWalletPostTransactionOrdersParams = {
  bizData?: string
  randomIv?: string
  randomKey?: string
  signature?: string
  timestamp?: number
}
export type TPostWalletPostTransactionOrdersResponse = TResponse<string>
export const postWalletPostTransactionOrders = (
  params?: TPostWalletPostTransactionOrdersParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostWalletPostTransactionOrdersResponse>(API.WalletPostTransactionOrders, params, {
    options: {
      signature: 'decrypted',
    },
  })
}
